import { useApi } from "../useApi";

export const useGeneratePasswordResetCode = () => {
  const loading = useState<boolean>("generatePasswordResetCode:loading", () => false);
  const error = useState<string | null>("generatePasswordResetCode:error", () => null);
  const api = useApi();

  const generatePasswordResetCode = async (email: string) => {
    try {
      error.value = null;
      loading.value = true;

      const base = api.request.config.BASE;
      await (await fetch(`${base}/v1/auth/generate-password-reset`, { 
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email })
      })).json();
    } catch (err) {
      error.value = "Failed to generate password reset code";
      console.error("Failed to generate password reset code:", err);
    } finally {
      loading.value = false;
    }
  };

  return {
    generatePasswordResetCode,
    loading,
    error,
  };
};
